/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetTestDto } from './GetTestDto';
import {
    GetTestDtoFromJSON,
    GetTestDtoFromJSONTyped,
    GetTestDtoToJSON,
} from './GetTestDto';
import type { GetExaminedDto } from './GetExaminedDto';
import {
    GetExaminedDtoFromJSON,
    GetExaminedDtoFromJSONTyped,
    GetExaminedDtoToJSON,
} from './GetExaminedDto';
import type { GetExamDto } from './GetExamDto';
import {
    GetExamDtoFromJSON,
    GetExamDtoFromJSONTyped,
    GetExamDtoToJSON,
} from './GetExamDto';

/**
 * 
 * @export
 * @interface GetAttachmentDto
 */
export interface GetAttachmentDto {
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof GetAttachmentDto
     */
    date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentDto
     */
    name?: string | null;
    /**
     * 
     * @type {GetExaminedDto}
     * @memberof GetAttachmentDto
     */
    examined?: GetExaminedDto | null;
    /**
     * 
     * @type {GetExamDto}
     * @memberof GetAttachmentDto
     */
    exam?: GetExamDto | null;
    /**
     * 
     * @type {GetTestDto}
     * @memberof GetAttachmentDto
     */
    test?: GetTestDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentDto
     */
    type?: GetAttachmentDtoTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentDto
     */
    taskNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentDto
     */
    storageKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentDto
     */
    objectId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAttachmentDto
     */
    fileSize?: string | null;
}


/**
 * @export
 */
export const GetAttachmentDtoTypeEnum = {
    Badanie_laboratoryjne: 'Badanie laboratoryjne',
    Skierowanie: 'Skierowanie',
    Skierowanie_zewntrzne: 'Skierowanie zewnętrzne',
    Orzeczenie: 'Orzeczenie',
    Orzeczenie_angielskie: 'Orzeczenie angielskie',
    Identyfikacja_badanego: 'Identyfikacja badanego',
    Zawiadczenie_od_diabetologa: 'Zaświadczenie od diabetologa',
    Skierowanie_ze_Starostwa_Policji: 'Skierowanie ze Starostwa/Policji',
    Zacznik_do_faktury: 'Załącznik do faktury',
    Zacznik_do_podrcznika: 'Załącznik do podręcznika'
} as const;
export type GetAttachmentDtoTypeEnum = typeof GetAttachmentDtoTypeEnum[keyof typeof GetAttachmentDtoTypeEnum];


/**
 * Check if a given object implements the GetAttachmentDto interface.
 */
export function instanceOfGetAttachmentDto(value: object): value is GetAttachmentDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetAttachmentDtoFromJSON(json: any): GetAttachmentDto {
    return GetAttachmentDtoFromJSONTyped(json, false);
}

export function GetAttachmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAttachmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'description': json['description'] == null ? undefined : json['description'],
        'name': json['name'] == null ? undefined : json['name'],
        'examined': json['examined'] == null ? undefined : GetExaminedDtoFromJSON(json['examined']),
        'exam': json['exam'] == null ? undefined : GetExamDtoFromJSON(json['exam']),
        'test': json['test'] == null ? undefined : GetTestDtoFromJSON(json['test']),
        'type': json['type'] == null ? undefined : json['type'],
        'taskNumber': json['taskNumber'] == null ? undefined : json['taskNumber'],
        'storageKey': json['storageKey'] == null ? undefined : json['storageKey'],
        'objectId': json['objectId'] == null ? undefined : json['objectId'],
        'fileSize': json['fileSize'] == null ? undefined : json['fileSize'],
    };
}

export function GetAttachmentDtoToJSON(value?: GetAttachmentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'date': value['date'] == null ? undefined : ((value['date'] as any).toISOString()),
        'description': value['description'],
        'name': value['name'],
        'examined': GetExaminedDtoToJSON(value['examined']),
        'exam': GetExamDtoToJSON(value['exam']),
        'test': GetTestDtoToJSON(value['test']),
        'type': value['type'],
        'taskNumber': value['taskNumber'],
        'storageKey': value['storageKey'],
        'objectId': value['objectId'],
        'fileSize': value['fileSize'],
    };
}

